const prefixes = ['', 'K', 'M', 'G', 'T'];

export const parseSize = (sizeStr: string) => {
  const [, size, unit] = sizeStr.match(/^([0-9]+(?:.[0-9]+)?)\s?([KMGT]?B?)$/) ?? [null, 0, ''];
  let unitIndex = prefixes.indexOf(String(unit).substr(0, 1));
  if (unitIndex === -1) unitIndex = 0;
  return Math.floor(Number(size) * Math.pow(1024, unitIndex));
};
